export const BANK_ID_ATTRIBUTE = 'data-bank-id';
export const BANK_ELEMENT_SELECTOR = `[${BANK_ID_ATTRIBUTE}]`;

export const MAUSOLEUM_PLAN_ALLOWED_TAGS = [
  'svg',
  'g',
  'path',
  'rect',
  'circle',
  'ellipse',
  'line',
  'polyline',
  'polygon',
  'text',
  'tspan',
  'defs',
  'image',
  'use',
  'clipPath',
  'mask',
  'pattern',
  'linearGradient',
  'radialGradient',
  'stop',
  'filter',
  'feBlend',
  'feColorMatrix',
  'feComposite',
  'feDropShadow',
  'feFlood',
  'feDisplacementMap',
  'feGaussianBlur',
  'feMerge',
  'feMergeNode',
  'feOffset',
  'feTurbulence',
];

export const MAUSOLEUM_PLAN_ALLOWED_ATTR = [
  BANK_ID_ATTRIBUTE,
  'aria-label',
  'class',
  'role',
  'xmlns',
  'xmlns:xlink',
  'id',
  'width',
  'height',
  'viewBox',
  'x',
  'y',
  'x1',
  'x2',
  'y1',
  'y2',
  'cx',
  'cy',
  'r',
  'rx',
  'ry',
  'd',
  'points',
  'transform',
  'fill',
  'fill-rule',
  'fill-opacity',
  'flood-opacity',
  'clip-rule',
  'clip-path',
  'stroke',
  'stroke-width',
  'stroke-linecap',
  'stroke-linejoin',
  'stroke-miterlimit',
  'stroke-dasharray',
  'stroke-dashoffset',
  'stroke-opacity',
  'opacity',
  'text-anchor',
  'font-family',
  'font-size',
  'font-weight',
  'dominant-baseline',
  'alignment-baseline',
  'dx',
  'dy',
  'offset',
  'stop-color',
  'stop-opacity',
  'mask',
  'filter',
  'filterUnits',
  'color-interpolation-filters',
  'gradientUnits',
  'gradientTransform',
  'patternUnits',
  'patternContentUnits',
  'preserveAspectRatio',
  'href',
  'xlink:href',
  'in',
  'in2',
  'mode',
  'result',
  'type',
  'baseFrequency',
  'numOctaves',
  'seed',
  'scale',
  'xChannelSelector',
  'yChannelSelector',
];
